import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

const TILES = [
  { key: "total_signups", label: "Total signups", color: "text-persimmon", bar: "bg-persimmon" },
  { key: "verified_pct", label: "Verified", suffix: "%", color: "text-signal", bar: "bg-signal" },
  { key: "new_signups_today", label: "Signups · today", color: "text-cobalt", bar: "bg-cobalt" },
  { key: "total_waitlist", label: "Total waitlist", color: "text-ink", bar: "bg-butter" },
  { key: "new_waitlist_today", label: "Waitlist · today", color: "text-ink", bar: "bg-ink" },
  { key: "leads_today", label: "Leads · today", color: "text-gold", bar: "bg-gold" },
  { key: "queries_today", label: "Queries · today", color: "text-cobalt", bar: "bg-cobalt" },
];

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setData(r.data)); }, []);

  return (
    <div>
      <div className="border-b border-ink pb-8">
        <div className="label-mono">Control room</div>
        <h1 className="mt-3 font-display font-black text-4xl md:text-5xl tracking-tightest text-ink leading-[1]"
          data-testid="admin-dashboard-title">
          Dashboard.
        </h1>
        <p className="mt-3 text-ink/65 max-w-xl">Quick view of signups, waitlist, leads, and queries.</p>
      </div>

      <div className="mt-10 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-px bg-rule border border-rule" data-testid="admin-tiles">
        {TILES.map((t) => (
          <div key={t.key} className="bg-white p-5 relative">
            <div className={`absolute top-0 left-0 right-0 h-1 ${t.bar}`} />
            <div className="label-mono">{t.label}</div>
            <div className={`mt-3 font-mono tabular font-medium text-3xl leading-none ${t.color}`}>
              {data ? `${data[t.key] ?? 0}${t.suffix || ""}` : "—"}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-10 border border-rule bg-white">
        <div className="border-b border-rule px-6 py-4 label-mono flex items-center justify-between">
          <span>Last 14 days · signups</span>
          <span className="text-ink/40">№ 01</span>
        </div>
        <div className="h-64 p-4">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data?.chart_14d || []} margin={{ top: 12, right: 18, left: 0, bottom: 8 }}>
              <CartesianGrid stroke="#E5E5E5" strokeDasharray="0" vertical={false} />
              <XAxis dataKey="date" stroke="#666" fontSize={10} tickLine={false} tickFormatter={(d) => d.slice(5)} />
              <YAxis stroke="#666" fontSize={10} tickLine={false} allowDecimals={false} />
              <Tooltip
                contentStyle={{ background: "#fff", border: "1px solid #111", borderRadius: 0, fontSize: 12 }}
                labelStyle={{ color: "#666", fontFamily: "IBM Plex Mono", fontSize: 10 }}
              />
              <Line type="linear" dataKey="signups" stroke="#FF5C28" strokeWidth={2} dot={{ r: 3, fill: "#FF5C28" }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
